import { Skeleton } from '@mui/material';
import { calculateLocatinVars } from '../../../libs/browser';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CommonDescription from '../../../components/CommonDescription';
import Context from '../../../provider';
import ErrorPage from '../../../pages/ErrorPage';
import HeaderBarComponent from '../../../components/HeaderBarComponent';
import IconAboutHKDC from '../../../assets/hkdc/icons/AboutHKDCIcon';
import IconHKDC from '../../../assets/hkdc/icons/HKDCIcon';
import MobileLogoFooterComponent from '../../../components/LogoFooterComponent';
import React, { useContext, useEffect, useRef, useState } from 'react';
import memberApi from '../../../libs/api/memberApi';
import useIsScrolling from '../../../hooks/useIsScrolling';
import useNotificationsCount from '../../../hooks/useNotificationsCount';
import './index.scss';

export default function MobileFellowPage() {
  const location = useLocation();
  const locationVars = calculateLocatinVars(location.pathname);
  const { init, dispatch, lang, me } = useContext(Context);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const notificationNotReadCount = useNotificationsCount();

  const scrollRef = useRef(null);
  const isScrolling = useIsScrolling(scrollRef.current);

  const [data, setData] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [pageNotFound, setPageNotFound] = useState(false);

  const fetchData = async () => {
    try {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: true });
      const page = await memberApi.getPage({ ruri: locationVars.join('/') });
      setData(page);
      setLoaded(true);
    } catch (error) {
      setPageNotFound(true);
    } finally {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: false });
    }
  };

  useEffect(() => {
    if (init) fetchData();
  }, [init]);

  // This page only allow logged in user
  useEffect(() => {
    // if (init) {
    //   if (!me) navigate(`${config.basename}login?redirect=${locationVars.join('/')}`);
    //   if (me?.status === 'new') navigate(`${config.basename}signup?redirect=${locationVars.join('/')}`);
    // }
  }, [init, me]);

  const getSectionStyle = (section) => {
    const style = {};
    if (section?.color_background_class) style.backgroundColor = section.color_background_class;
    if (section?.color_foreground_class) style.color = section.color_foreground_class;
    if (section?.background_texture) style.backgroundImage = `url(${section.background_texture})`;
    return style;
  };

  return (
    <>
      {pageNotFound && <ErrorPage type="notFound" />}
      {!pageNotFound && (
        <div className='mobile-fellow-page'>
          <HeaderBarComponent
            homeIcon={
              <IconHKDC
                style={{ width: '5rem', height: '2.78rem' }}
                onClick={(e) => {
                  e.stopPropagation();
                  window.location.assign('https://www.hkdesigncentre.org/ ');
                }}
              />
            }
          />

          <div ref={scrollRef} className='y-overflow content-container'>
            <div className="title-icon-container">
              <div className="icon-container">
                <IconAboutHKDC
                  className="icon"
                  size="large" />
              </div>
              <div className="news-titles-container">
                <div className="title">
                  {data?.title?.[lang]}
                </div>
                <div className="desc">
                  {data?.meta_description?.[lang]}
                </div>
              </div>
            </div>

            {data?.sections && data.sections.length > 0 && data.sections[0].image[lang] && <div className='img-cont' style={{ backgroundImage: `url(${data.sections[0].image?.[lang]})` }} />}
            <div className='app-container'>
              {loaded && (data?.sections ??[]).map((section, index) => {
                return (
                  <section className={ section.color_background_class ?? 'common-section' } key={`${section.anchor}-${index}`} style={getSectionStyle(section)}>
                    <div className="section-content-cont">
                      {
                        section.image[lang] &&
                        <div className='img-cont' style={{ backgroundImage: `url(${section.image[lang]})` }} />
                      }
                      <CommonDescription
                        title={section.hide_title ? null : section?.title?.[lang]}
                        data={section?.content?.[lang]}
                      />
                    </div>
                  </section>
                );
              })}
              {!loaded && (
                <>
                  <Skeleton animation="wave" variant="rounded" height={16} width='80%' className='skeleton' />
                  <Skeleton animation="wave" variant="rounded" height={16} width='100%' className='skeleton' />
                  <Skeleton animation="wave" variant="rounded" height={16} width='50%' className='skeleton' />
                </>
              )}
            </div>
            <MobileLogoFooterComponent />
            <div style={{ height: '10rem', backgroundColor: '#000000' }} />
          </div>
        </div>
      )}
    </>
  );
}